import { Injectable, inject } from '@angular/core';
import { Observable, from, map } from 'rxjs';
import { TranslateService } from '../../services/translate.service';

@Injectable({
  providedIn: 'root',
})
export class TranslationsLoadedGuard {
  private translateService = inject(TranslateService);

  canActivate(): Observable<boolean> {
    return from(this.translateService.get('')).pipe(map(() => true));
  }
}
